import { Button, Stack, Typography } from "@mui/joy";
import useOpenTask from "hooks/useOpenTask";
import useSubscriptionStatus from "hooks/useSubscriptionStatus";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import { userAtom } from "recoil/userAtom";
import { theme } from "../../styles/theme";
import useIsInappWebview from "../../hooks/useIsInappWebview";

export default function PaymentModule({
  title,
  subtitle,
  type,
}: {
  title?: string;
  subtitle?: string;
  type?: "header" | "footer";
}) {
  const openPayment = useOpenTask({ taskKey: `payment` });
  const isInappWebview = useIsInappWebview();

  const user = useRecoilValue(userAtom);
  const subscription = user?.subscription;

  const { t: t_payment } = useTranslation("translation", {
    keyPrefix: "payment",
  });

  const text = {
    expired: {
      title: t_payment(`이용 기간이 만료되었어요`),
      subtitle: t_payment(`다시 결제하고 프로그램을 이어가세요.`),
    },
    notstarted: {
      title: `결제하고 다음 활동을 받아보세요`,
      subtitle: `매일 활동지가 제공될 거예요.`,
    },
  };
  const { isExpired, isNotStarted } = useSubscriptionStatus();

  return (
    <Stack
      sx={{
        width: "100%",
        backgroundColor: "white",
      }}
    >
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        spacing="32px"
        alignItems="center"
        sx={{
          width: "100%",
          maxWidth: "660px",
          mx: "auto",
          px: "24px",
          py: "16px",
        }}
      >
        <Stack spacing={"2px"}>
          <Typography
            variant="Body"
            sx={{
              color: theme.vars.palette.Content.Strong,
              fontWeight: 700,
              pr: 0,
            }}
          >
            {title !== undefined
              ? title
              : isExpired
                ? text["expired"].title
                : isNotStarted
                  ? text["notstarted"].title
                  : text["notstarted"].title}
          </Typography>
          <Typography
            variant="Caption"
            sx={{
              color: theme.vars.palette.Content.Weak,
              fontWeight: 500,
              pr: 0,
            }}
          >
            {subtitle !== undefined
              ? subtitle
              : isExpired
                ? text["expired"].subtitle
                : isNotStarted
                  ? text["notstarted"].subtitle
                  : text["notstarted"].subtitle}
          </Typography>
        </Stack>
        <Button
          size="sm"
          onClick={() => {
            openPayment();
          }}
          sx={{
            whiteSpace: "nowrap",
            minWidth: "auto",
          }}
        >
          {t_payment("더 알아보기")}
        </Button>
      </Stack>
    </Stack>
  );
}
